// Slider.tsx
import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/autoplay";
import { Slide } from "../../types/Slide";
import './Slider.scss'
import { HomeSlider } from "../../types/HomeSlider";

interface SliderProps {
  slides: HomeSlider[];
}

export default function Slider({ slides }:SliderProps){
  return (
    <Swiper
      spaceBetween={30}
      centeredSlides={true}
      autoplay={{
        delay: 5000,
        disableOnInteraction: false,
      }}
      pagination={{
        clickable: false,
      }}
      navigation={false}

      modules={[Autoplay, Navigation]}
      className="mySwiper"
    >
      {slides.map((slide) => (
        <SwiperSlide key={slide?.index}>
          <a href={slide?.url ?? '/'} target="_blank" rel="noopener noreferrer" style={{width:'100%',height:'100%'}}>
            <picture>
              <source media="(max-width: 768px)" srcSet={slide?.mobile} />
              <img src={slide?.desktop} alt={`Slide ${slide.index}`} />
            </picture>
          </a>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

